const initialDriver = {
    driverLists: [],
    driverStatus: [],
    driverPermissions: {},
    changedDriverStatus : [],
    changedDriverPhoto : [],
    changedDriverRegistration : [],
    loadingDriver: false,
    errorsDriver: {}
}

const  driverReducer = (state = initialDriver, action) => {
    switch (action.type) {
        case "GET_DRIVERLIST_PENDING":
        case "ADD_DRIVER_PENDING":
        case "UPDATE_DRIVER_PENDING":
        case "UPDATE_DRIVER_STATUS_PENDING":
        case "LOGOUT_DRIVER_DEVICE_PENDING":
        case "DELETE_DRIVER_PENDING":
        case "GET_DRIVERLISTBYID_PENDING":
        case "RESET_DRIVER_REGISTRATION_PENDING":
        case "RESET_DRIVER_PHOTO_PENDING":
        case "ADD_DRIVER_PHOTO_PENDING":
                return { ...state, loadingDriver: true };

        case "GET_DRIVERLIST_FULFILLED":
            return {
                ...state,
                loadingDriver: false,
                driverLists: action.payload,
                driverCount: action.driverCount,
                driverPermissions:action.permissions,
            };

        case "ADD_DRIVER_FULFILLED":
            return {
                ...state,
                loadingDriver: false,
                changedDriverStatus: action.payload,
            };
        case "ADD_DRIVER_PHOTO_FULFILLED":
            return {
                ...state,
                loadingDriver: false,
                changedDriverPhoto: action.payload,
            };
        case "RESET_DRIVER_REGISTRATION_FULFILLED":
            return {
                ...state,
                loadingDriver: false,
                changedDriverRegistration: action.payload,
            };
        case "UPDATE_DRIVER_FULFILLED":
            return {
                ...state,
                loadingDriver: false,
                changedDriverStatus: action.payload,
            };

        case "UPDATE_DRIVER_STATUS_FULFILLED":
            return {
                ...state,
                loadingDriver: false,
                changedDriverStatus: action.payload,
            };

        case "LOGOUT_DRIVER_DEVICE_FULFILLED":
            return {
                ...state,
                loadingDriver: false,
                changedDriverStatus: action.payload,
                changedDriverRegistration: action.payload,
                changedDriverPhoto: action.payload,
            };

        case "GET_DRIVERLISTBYID_FULFILLED":
            return {
                ...state,
                loadingDriver: false,
                driverLists: action.payload
            };

        case "DELETE_DRIVER_FULFILLED":
            return {
                ...state,
                loadingDriver: false,
                changedDriverStatus: action.payload
            };

        case "RESET_DELETE_DRIVER_STATUS":
            return {
                ...state,
                loadingDriver: false,
                changedDriverStatus: [],
                errorsDriver:{}
            };

        case "GET_DRIVERLIST_REJECTED":
        case "ADD_DRIVER_REJECTED":
        case "UPDATE_DRIVER_REJECTED":
        case "UPDATE_DRIVER_STATUS_REJECTED":
        case "LOGOUT_DRIVER_DEVICE_REJECTED":
        case "DELETE_DRIVER_REJECTED":
        case "GET_DRIVERLISTBYID_REJECTED":
        case "RESET_DRIVER_REGISTRATION_REJECTED":
        case "RESET_DRIVER_PHOTO_REJECTED":
        case "ADD_DRIVER_PHOTO_REJECTED":
                return {
                ...state,
                loadingDriver: false,
                errorsDriver: action.payload
            };

        default:
            return state;
    }
}

export default driverReducer;
